var icon = require('vue-svgicon');
// console.log('');
icon.register({
  'linkedin': {
    width: 36.1,
    height: 36,
    viewBox: '0 0 36.099999 36',
    data: `<path pid="0" d="M33.3 0H2.7C1.2 0 0 1.2 0 2.6v30.8C0 34.8 1.2 36 2.7 36h30.7c1.5 0 2.7-1.2 2.7-2.6V2.6C36 1.2 34.8 0 33.3 0zM10.7 30.7H5.3V13.5h5.3v17.2zM8 11.1c-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3 3.1-3 1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3-3.1 3zm22.7 19.6h-5.3v-8.4c0-2 0-4.6-2.8-4.6s-3.2 2.2-3.2 4.4v8.5H14V13.5h5.1v2.3h.1c.7-1.4 2.5-2.8 5.1-2.8 5.4 0 6.4 3.6 6.4 8.2z"/>`
  }
});



// WEBPACK FOOTER //
// ./src/icons/linkedin.js